<template>
  <div class="header">
    <div class="header-item">
      <el-input
        type="text"
        placeholder="请输入充电站名称，按enter进行搜索"
        v-model="elecName"
        clearable
        @keyup.enter.native="onSearch"
        @clear="onClear"
      ></el-input>
    </div>
    <div class="header-item">
      <el-button type="primary" @click="onUpload">上传</el-button>
    </div>
    <upload
      v-if="isUploadDialogVisiable"
      :isDialogShow="isUploadDialogVisiable"
      :stationList="stationList"
      @onClose="onUploadClose"
    ></upload>
  </div>
</template>

<script>
import Upload from "./Upload.vue";
export default {
  name: "Header",
  props: {
    stationList: {
      type: Array,
    },
  },
  components: {
    Upload,
  },
  data() {
    return {
      elecName: "",
      isUploadDialogVisiable: false,
    };
  },
  watch: {
    elecName(val) {
      if (val.length === 0) {
        this.$emit("onSearch", "");
      }
    },
  },
  methods: {
    onSearch() {
      if (this.elecName.length > 0) {
        this.$emit("onSearch", this.elecName);
      }
    },
    onClear() {
      this.$emit("onSearch", "");
    },
    onUpload() {
      this.isUploadDialogVisiable = true;
    },
    onUploadClose() {
      this.isUploadDialogVisiable = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 60px;
  z-index: 10;
  right: 100px;
  width: 400px;
  display: flex;
  height: 40px;
  &-item {
    &:first-child {
      margin-right: 20px;
      width: 300px;
    }
  }
}
</style>
